

// Allowed characters for each field.
export const ALLOWED_CHARACTERS_REGEX = {
  name: /^[\p{L}\p{M}' -]+$/u,
  city: /^[\p{L}\p{M}' -]+$/u,
  street: /^[\p{L}\p{M}0-9' -]+$/u,
  zipcode: /^[\p{L}0-9 -]+$/u
};

// Allowed length for each field.
export const ALLOWED_LENGTHS_REGEX = {
  name: /^.{0,80}$/,     // up to 80 chars
  city: /^.{0,50}$/,      // up to 50 chars
  street: /^.{0,100}$/,   // up to 100 chars
  zipcode: /^.{3,10}$/    // 3–10 chars
};

/** Loose email shape (something@domain.tld, no spaces): the API has the final say. */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
